export enum PaymentResult {
  Success = 'Successful',
  Unsuccessful = 'Unsuccessful',
}
